// Ocean Breeze - Blues and teals, cool coastal palette
// Key colors:
//   Deep Ocean #0B3D5C - backgrounds, headers, dark UI
//   Aqua Teal #2EC4B6 - CTAs, highlights, action buttons
//   Sky Blue #48A9C5 - secondary elements
//   Seafoam #A8E6CF - success states, availability indicators
//   Pale Mist #F0F9FF - card backgrounds, text areas, light base
//   Coral Sand #E8927C - accents, badges, notification dots

export const lightTheme = {
  name: 'light',

  /* === Brand === */
  primaryColor: '#2EC4B6', // Aqua Teal - CTAs, highlights
  primaryDark: '#22A89C', // Deeper teal - hover states
  secondaryColor: '#48A9C5', // Sky Blue - secondary elements

  successColor: '#A8E6CF', // Seafoam - availability, success
  dangerColor: '#ef4444', // Red - errors, destructive actions
  warningColor: '#f59e0b', // Amber - warnings
  infoColor: '#48A9C5', // Sky Blue - informational

  /* === Backgrounds === */
  bgPrimary: '#F0F9FF', // Pale Mist - main background
  bgSecondary: '#E0F2FE', // Light sky
  bgTertiary: '#D0EAFF', // Soft blue

  background: '#D0EAFF', // Page background
  cardBackground: '#ffffff', // White cards
  hoverBackground: '#E0F2FE', // Light hover

  /* === Text === */
  textPrimary: '#0B3D5C', // Deep Ocean
  textSecondary: '#1A5F7A', // Mid ocean
  textMuted: '#4A8BA8', // Muted blue

  /* === Borders & Shadows === */
  borderColor: '#B3D8E8', // Soft blue border

  shadow: '0 1px 3px 0 rgba(11, 61, 92, 0.18), 0 1px 2px 0 rgba(0, 0, 0, 0.14)',
  shadowLg:
    '0 10px 25px -5px rgba(11, 61, 92, 0.35), 0 8px 10px -6px rgba(0, 0, 0, 0.35)',

  primaryHover: '#1AAFA2', // --primary-hover
  primaryStrong: '#108075', // --primary-strong (deep teal, gradient endpoint)
  accentColor: '#E8927C', // --accent-color (Coral Sand)
  shadowMd:
    '0 4px 12px -2px rgba(11, 61, 92, 0.22), 0 2px 6px -1px rgba(0, 0, 0, 0.18)', // --shadow-md
  shadowXl:
    '0 20px 50px -10px rgba(11, 61, 92, 0.45), 0 12px 20px -8px rgba(0, 0, 0, 0.4)', // --shadow-xl
  shadowSoft: 'rgba(46, 196, 182, 0.12)', // --shadow-soft

  /* === Messaging / States === */
  primaryLight: 'rgba(46, 196, 182, 0.14)', // Aqua Teal tint
  unreadBackground: 'rgba(46, 196, 182, 0.06)',
  messageBubbleBg: '#E0F2FE',
  messageReceivedBg: '#ffffff',
  dangerLight: 'rgba(239, 68, 68, 0.1)',
};

export const darkTheme = {
  name: 'dark',

  /* === Brand === */
  primaryColor: '#2EC4B6', // Aqua Teal - CTAs, highlights
  primaryDark: '#22A89C', // Deeper teal - hover states
  secondaryColor: '#48A9C5', // Sky Blue - secondary elements

  successColor: '#A8E6CF', // Seafoam - availability, success
  dangerColor: '#ef4444', // Red - errors, destructive actions
  warningColor: '#f59e0b', // Amber - warnings
  infoColor: '#48A9C5', // Sky Blue - informational

  /* === Backgrounds === */
  bgPrimary: '#061926', // Deep ocean
  bgSecondary: '#0B3D5C', // Deep Ocean
  bgTertiary: '#14506F', // Lighter ocean

  background: '#061926', // Page background
  cardBackground: '#0B3D5C', // Deep Ocean cards
  hoverBackground: '#14506F', // Hover

  /* === Text === */
  textPrimary: '#F0F9FF', // Pale Mist
  textSecondary: '#7CC4D8', // Light aqua
  textMuted: '#5A9DB5', // Muted aqua

  /* === Borders & Shadows === */
  borderColor: '#1A5F7A', // Mid ocean border

  shadow: '0 1px 3px 0 rgba(46, 196, 182, 0.3), 0 1px 2px 0 rgba(0, 0, 0, 0.8)',
  shadowLg:
    '0 18px 35px -10px rgba(0, 0, 0, 0.9), 0 0 40px rgba(46, 196, 182, 0.25)',

  primaryHover: '#48D8CA', // --primary-hover
  primaryStrong: '#7BFFE6', // --primary-strong (vivid aqua, gradient endpoint)
  accentColor: '#48A9C5', // --accent-color (Sky Blue)
  shadowMd:
    '0 4px 12px -2px rgba(46, 196, 182, 0.3), 0 2px 6px -1px rgba(0, 0, 0, 0.6)', // --shadow-md
  shadowXl:
    '0 28px 60px -14px rgba(0, 0, 0, 0.95), 0 0 60px rgba(46, 196, 182, 0.35)', // --shadow-xl
  shadowSoft: 'rgba(46, 196, 182, 0.2)', // --shadow-soft

  /* === Messaging / States === */
  primaryLight: 'rgba(46, 196, 182, 0.3)', // Aqua Teal tint
  unreadBackground: 'rgba(46, 196, 182, 0.16)',
  messageBubbleBg: '#14506F',
  messageReceivedBg: '#1A6580',
  dangerLight: 'rgba(239, 68, 68, 0.25)',
};

export const themes = {
  light: lightTheme,
  dark: darkTheme,
};
